module.exports = __webpack_public_path__ + "media/landing_work/home/images/back_end-0c1b0ad758d845823920cc253d9f5099.svg";